
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe10 as ObiHydraulicPipe10Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-10.js';
 
 
 

 
 export const ObiHydraulicPipe10 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-10',
   elementClass: ObiHydraulicPipe10Element,
   events: {
     
   }
  });
 
 